import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="The Stupidity of Prospecting" />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/&amp;title=The%20Stupidity%20of%20Prospecting&amp;summary=The%20Stupidity%20of%20Prospecting&amp;source=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=The%20Stupidity%20of%20Prospecting&amp;url=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=The%20Stupidity%20of%20Prospecting&amp;body=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-challenge-reach.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>The Stupidity of Prospecting</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>9 January 2017</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Sales Prospecting – are you just digging up dirt?</h3>
<p>To maintain sales velocity and competitiveness sales professionals need to continuously improve how they do things and that means they have to reconsider the tools they have in their sales stack. </p>
<div className="rich-text"><p>The term “prospecting” stems from the old days of searching for mineral deposits, in particular gold. Throughout my career in B2B sales I have been constantly told that “prospecting” is the Number#1 critical element in driving pipeline development and that you must have an adequate sized pipeline if you are going to be successful. Unfortunately there are still far too many sales leaders that continue to manage and measure ‘prospecting’ the way they always have and most of these old approaches no longer work when compared with the power of the modern tools. Allow me to explain:</p><h3><strong>The Gold Rush:</strong></h3><p>Edward Hargraves and James Esmond both went from Australia to the Californian gold rush in 1849, both returned to Australia in 1851. Hargraves went to Bathurst (Australia) where there were similar geological features to the California goldfield and he found gold in a creek bed. The Australian gold rush ensued. Back then, in order to decide <strong>where</strong> to look for gold was an unsophisticated process to say the least. These ‘prospectors’ would simply look in areas/landscapes with similar physical appearance or geological features - creek beds mainly, or near where others had already discovered gold. Please bear with me, there is a reason that I’m conveying this seemingly unrelated historical context.</p><p>In order to find a gold nugget, the old timers would take a pick, shovel and gold panning dish, dig up soil, gravel and/or sand from creek bed and wash it in a panning dish, swirl water so gold specks or nuggets sink to the bottom and they would then tip the soil, gravel and sand off until only gold is left. If you think about it this is effectively what sales people are doing with traditional forms of prospecting such as cold calling. That is, sifting through mountains of dirt in order to find a small piece of gold.</p><p>Fast forward to 2018, and both science and technology have made the search for gold a much more accurate, sophisticated and effective process. Deciding where to look is no longer luck or simple observation. Modern prospectors investigate the geology of target areas and then utilise geotechnical engineering computers and technology to identify higher grade (and more financially viable) deposits. Modern tools enable ‘sampling’ - digging or dredging holes to locate the gold path or seam, and modern methods and machinery then allow large quantities of rock to be processed in a much shorter time, meaning more gold is obtained per tonne of rock processed and per man hour of labor. Hence, the luck factor is dramatically reduced using all of these modern tools. </p></div>
<img alt="the gold rush" className="img-responsive" height="261" src="../../../media/images/AAEAAQAAAAAAAAjDAAAAJDJiMDc4ZWE4LWRkYjEtNGQ2MS.width-647.jpg" width="647"/>

<div className="rich-text"><h3><strong>The Stupidity of Prospecting in 2018,</strong></h3><p>The truly erroneous part about the traditional to approach prospecting is the extent to which it only focuses on 'active' buyers. As Chet Holmes said, "only 3% of your Target Addressable Market (TAM) is ever in a buying window at any given point in time". That means that when we prospect we are only looking for 'active' buyers which completely excludes and ignores the other 97% of your TAM.</p><p>That's just plain stupid in 2018 and beyond....especially when platforms like HubSpot allow us to easily identify the active and passive buyers, and create 'buying stage appropriate messaging' for each group as required. Then we can 'nurture and grow' the passive buyers until they do move into a buying window. Put simply, prospecting just focuses (in the vast majority of cases) on a small minority of your market - the 3% of active buyers - and that's ridiculous today. </p><p><img className="richtext-image full-width" src="../../../media/images/Image7_cropped.width-800.png" width="634" height="279" alt="Propecting Cropped"/><br/></p><h3><strong>So, why are so many sales leaders still stuck using the old 'pick and shovel'?</strong></h3><p>Like the modern approach to gold mining, today’s sales people now have a raft of new technologies at their disposal that can make the task of ‘prospecting’ so much more effective:</p><ul><li><strong>Predictive analytics</strong> – mining ‘big data’ to gain clearer insights around buyer tastes and preferences. Narrowing the focus on key buying ‘trigger points’, and important market trends.</li><li><strong>Marketing Automation</strong> –sending the right (personalized) messages to the right buyers, at the right time. That is, creating ‘buying stage appropriate’ messaging. Remembering that increased personalisation means decreased rejection.</li><li><strong>Content Marketing</strong> – generating awareness, <em>thought leadership</em> and customer value without pitching. Creating that all important ‘inbound’ which dramatically reduces the Cost of Customer Acquisition (COCA)</li><li><strong>Social Engagement</strong> – using social channels to ‘listen’ and engage. To generate a cross-channel approach to better understand customers or prospects, but never pitching on social.</li><li><strong>Lead Management &amp; Nurturing</strong> – utilizing sophisticated lead generation/demand creation tools and techniques that capture critical customer data. Building long term nurturing programs and conversion pathways. According to Forrester, “companies that nurture leads make 50% more sales at a cost 33% less than non-nurtured leads”.</li><li><strong>Sales Engagement Platforms</strong> – helping set and execute on a cadence of phone, email, and social communications to convert target accounts by integrating content, communications and actionable insights to improve customer engagements.</li><li><strong>Re-marketing</strong> – using a mix of the above to more accurately target and engage buyers based on their previous actions and behaviors.</li></ul><p>Is anyone surprised that we no longer see people in creek beds panning for gold? Then why are so many sales people still utilizing so many horribly outdated sales techniques and tools when so much technology is now available? Whether you are an old sales dog like me (trying to learn new tricks) or a new comer in the Millennial demographic, if you are in a B2B sales role in 2018 then do yourself a favor and stop ‘panning for gold’, and start learning about ALL of the tools that you now have at your disposal.</p><p>If you keep prospecting like its still 1990 then your chances of being successful in 2018 and beyond are roughly about the same as Hargraves and Esmond had back in 1851, except they were at least operating in an emerging high growth market. Meanwhile, the early adopters of the above tools and technologies (ie. your competitors) are now finding all the gold.</p><p>What do you think? Is your sales team prospecting with a pan? Leveraging the power of modern tools? If so, then let me know if you need help with creating quality leads in the modern way.....it's not rocket science. </p><p>graham@salestribe.com </p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/&amp;title=The%20Stupidity%20of%20Prospecting&amp;summary=The%20Stupidity%20of%20Prospecting&amp;source=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=The%20Stupidity%20of%20Prospecting&amp;url=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=The%20Stupidity%20of%20Prospecting&amp;body=https%3A//salestribe.com/knowledge-centre/insights/too-many-sales-people-are-panning-gold/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>


      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 